import { useEffect, useState } from 'react';

/**
 * This is a basic implementation of displaying the feature highlights component that
 * utilizes browser storage.
 * This should be replaced with a backend persisted flag dependent hook.
 *
 */
export const useOnboarding = () => {
  const [shouldShowFeatureHighlights, setShouldShowFeatureHighlights] =
    useState(false);

  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    // TODO: Update to use backend flag
    setShouldShowFeatureHighlights(
      window.localStorage.getItem('showFeatureHighlights') !== 'false',
    );
    setLoading(false);
  }, []);

  const onOnboardingComplete = (error?: Error) => {
    if (!error) {
      window.localStorage.setItem('showFeatureHighlights', 'false');
    }
    setShouldShowFeatureHighlights(false);
  };

  return { shouldShowFeatureHighlights, isLoading, onOnboardingComplete };
};
